import {NavItem} from './nav-item/nav-item';
import {environment} from '../../../../environments/environment';
import {
  isEnrichRuntimeStatusSupported
} from '../../../components/enrich/runtime-status/runtime-status-capability';

export function getEnrichRuntimeStatusNavItems(environmentName: string): NavItem[] {
  if (!isEnrichRuntimeStatusSupported(environmentName)) {
    return [];
  }

  return [{
    displayName: 'Runtime Status',
    iconName: 'shield-lock',
    route: '/enrich/runtime-status',
    productType: 'Shine Enrich',
  }];
}

export const navItems: NavItem[] = [
  // Common items
  {
    displayName: 'Dashboard',
    iconName: 'layout-grid-add',
      route: '/ai/dashboard',
      productType: 'Shine AI',
  },

  // Shine AI specific items
  {
    navCap: 'Chat Agents',
      productType: 'Shine AI',
  },
  {
    displayName: 'Chatbots',
    iconName: 'users',
    route: '/ai/chatbots',
      productType: 'Shine AI',
  },
  {
    displayName: 'Assistants',
    iconName: 'user',
    route: '/ai/assistants',
      productType: 'Shine AI',
  },
  {
    displayName: 'Conversations',
    iconName: 'messages',
    route: '/ai/conversations',
      productType: 'Shine AI',
  },
  {
    navCap: 'Routines',
      productType: 'Shine AI',
  },
  {
    displayName: 'Tasks',
    iconName: 'automation',
    route: '/ai/tasks',
      productType: 'Shine AI',
  },
  {
    displayName: 'Workflows',
    iconName: 'growth',
    route: '/ai/workflows',
      productType: 'Shine AI',
  },
  {
    navCap: 'Data',
      productType: 'Shine AI',
  },
  {
    displayName: 'Product Feeds',
    iconName: 'building-store',
    route: '/ai/product-feeds',
      productType: 'Shine AI',
  },
  {
    displayName: 'Product Analytics',
    iconName: 'presentation-analytics',
    route: '/ai/product-card-analytics',
      productType: 'Shine AI',
  },
  {
    displayName: 'Functions',
    iconName: 'math-function',
    route: '/ai/functions',
      productType: 'Shine AI',
  },
  {
    displayName: 'Files',
    iconName: 'files',
    route: '/ai/files',
      productType: 'Shine AI',
  },

    // Shine Translations
    {
        navCap: 'Translations',
        productType: 'Shine Translations',
    },
    {
        displayName: 'Translations',
        iconName: 'sparkles',
        route: '/translations',
        productType: 'Shine Translations',
    },

    // Shine Performance
    {
        displayName: 'Overview',
        iconName: 'presentation-analytics',
        route: '/performance',
        productType: 'Shine Performance',
    },

    // Shine Connect specific items
    {
        displayName: 'Integrations',
      iconName: 'automation',
        route: '/connect/integrations',
        productType: 'Shine Connect',
    },

  // Shine Enrich specific items
  {
    navCap: 'HubSpot Integration',
      productType: 'Shine Enrich',
  },
  {
    displayName: 'Setup',
    iconName: 'settings-2',
    route: '/enrich/setup',
      productType: 'Shine Enrich',
  },
  ...getEnrichRuntimeStatusNavItems(environment.environment),
  {
    displayName: 'Settings',
    iconName: 'settings',
    route: '/enrich/settings',
      productType: 'Shine Enrich',
    requiredReadiness: ['connection', 'scopes'],
  },
  {
    displayName: 'Field Mapping',
    iconName: 'arrows-exchange',
    route: '/enrich/mapping',
      productType: 'Shine Enrich',
    requiredReadiness: ['connection', 'scopes', 'properties'],
  },
  {
    navCap: 'Company Data',
    availableInLocalSearch: true,
      productType: 'Shine Enrich',
    requiresOperationalReadiness: true,
  },
  {
    displayName: 'Search',
    iconName: 'building',
    route: '/enrich/companies',
    availableInLocalSearch: true,
      productType: 'Shine Enrich',
    requiresOperationalReadiness: true,
  },
  {
    displayName: 'Imports',
    iconName: 'filter',
    route: '/enrich/filters',
    availableInLocalSearch: true,
      productType: 'Shine Enrich',
    requiresOperationalReadiness: true,
  },
  {
    displayName: 'Sync History',
    iconName: 'history',
    route: '/enrich/sync-history',
      productType: 'Shine Enrich',
    requiresOperationalReadiness: true,
  },

    // Shine Webinars
    {
        displayName: 'Webinars',
        iconName: 'presentation-analytics',
        route: '/webinars',
        productType: 'Shine Webinars',
    },
    {
        displayName: 'Webinars Settings',
        iconName: 'settings-2',
        route: '/webinars/settings',
        productType: 'Shine Webinars',
  }
];
